(function () {
  'use strict';

  if (window.RRRetreatVariants) return;

  var state = {
    form: null,
    variantInput: null,
    variants: [],
    currentVariant: null
  };

  function getVariant(id) {
    return state.variants.find(function (variant) {
      return String(variant.id) === String(id);
    });
  }

  function updateStickyPrice(variant) {
    var mainPrice = document.querySelector('.gsp-main-product-block-price .gsp-product-price');
    if (!mainPrice) return;
    document.querySelectorAll('[data-rr-sticky-price]').forEach(function (wrapper) {
      var priceRoot = wrapper.querySelector('.gsp-product-price');
      if (!priceRoot) return;
      priceRoot.className = mainPrice.className;
      priceRoot.innerHTML = mainPrice.innerHTML;
      priceRoot.classList.toggle('gsp-price-sold-out', !variant.available);
    });
  }

  function observeNativePrice() {
    var mainPrice = document.querySelector('.gsp-main-product-block-price .gsp-product-price');
    if (!mainPrice || !('MutationObserver' in window)) return;
    new MutationObserver(function () {
      if (state.currentVariant) updateStickyPrice(state.currentVariant);
    }).observe(mainPrice, { childList: true, subtree: true, characterData: true, attributes: true });
  }

  function updateSticky(variant) {
    document.querySelectorAll('[data-rr-sticky-variant]').forEach(function (element) {
      element.textContent = variant.public_title || variant.title || '';
    });

    document.querySelectorAll('[data-rr-sticky-stock]').forEach(function (element) {
      var quantity = Number(variant.inventory_quantity);
      var tracksInventory = variant.inventory_management && Number.isFinite(quantity);
      if (!variant.available) element.textContent = element.dataset.soldOutLabel;
      else if (element.dataset.showQuantity === 'true' && tracksInventory) {
        element.textContent = element.dataset.quantityLabel.replace('[x]', quantity);
      } else element.textContent = element.dataset.availableLabel;
    });

    document.querySelectorAll('[data-rr-sticky-submit]').forEach(function (button) {
      button.disabled = !variant.available;
      var label = button.querySelector('[data-rr-sticky-button-label]');
      if (label) label.textContent = variant.available ? button.dataset.availableLabel : button.dataset.soldOutLabel;
    });

    updateStickyPrice(variant);
  }

  function updateRoomCards(variant) {
    document.querySelectorAll('[data-rr-room-variant]').forEach(function (card) {
      var cardVariant = getVariant(card.dataset.rrRoomVariant);
      var selected = Boolean(cardVariant && String(cardVariant.id) === String(variant.id));
      var soldOut = Boolean(cardVariant && !cardVariant.available);
      var button = card.querySelector('[data-rr-select-room]');

      card.classList.toggle('is-selected', selected);
      card.classList.toggle('is-sold-out', soldOut);
      card.setAttribute('data-selected', selected ? 'true' : 'false');
      if (!button) return;
      button.disabled = selected || soldOut;
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.textContent = soldOut
        ? button.dataset.soldOutLabel
        : (selected ? button.dataset.selectedLabel : button.dataset.selectLabel);
    });
  }


  function formatInstallmentMoney(cents, currency) {
    var locale = document.documentElement.lang || 'fr-FR';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency || 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function updateInstallments(variant) {
    document.querySelectorAll('[data-rr-paypal-installments]').forEach(function (element) {
      var count = Number(element.dataset.installmentCount) || 4;
      var min = Number(element.dataset.minCents) || 0;
      var max = Number(element.dataset.maxCents) || Number.MAX_SAFE_INTEGER;
      var price = Number(variant.price) || 0;
      var eligible = price >= min && price <= max;
      var hideOutsideRange = element.dataset.hideOutsideRange === 'true';

      element.hidden = hideOutsideRange && !eligible;

      var amount = element.querySelector('[data-rr-paypal-amount]');
      if (!amount) return;
      var formatted = formatInstallmentMoney(price / count, element.dataset.currency);
      amount.textContent = (element.dataset.amountTemplate || '[amount]').replace('[amount]', formatted);
    });
  }

  function applyVariant(variant) {
    if (!variant) return;
    state.currentVariant = variant;
    updateSticky(variant);
    updateRoomCards(variant);
    updateInstallments(variant);
  }

  function setSubmitting(active) {
    var mainButton = state.form && state.form.querySelector('[type="submit"][name="add"]');
    var buttons = Array.prototype.slice.call(document.querySelectorAll('[data-rr-sticky-submit]'));
    if (mainButton) buttons.push(mainButton);
    buttons.forEach(function (button) { button.disabled = active || !state.currentVariant || !state.currentVariant.available; });
  }

  function showCartError(message) {
    if (window.gspNotification) {
      window.gspNotification.show({
        target: document.body,
        message: message,
        type: 'danger',
        method: 'appendChild',
        icon: 'circle_xmark',
        sticky: true
      });
    }
  }

  function submitProduct() {
    var drawer = document.querySelector('gsp-cart-drawer');
    if (!drawer || !state.form) return;

    var formData = new FormData(state.form);
    if (typeof drawer.getSectionsToRender === 'function') {
      var sections = drawer.getSectionsToRender().map(function (section) { return section.id; });
      formData.append('sections', Array.from(new Set(sections)).join(','));
      formData.append('sections_url', window.location.pathname);
    }

    setSubmitting(true);
    fetch((window.gspSetting && window.gspSetting.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: formData
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) throw response;
        drawer.classList.remove('gsp-cart-empty');
        drawer.renderContents(response);
        if (window.gspUpdateCartCountInHeader) window.gspUpdateCartCountInHeader.update();
      })
      .catch(function (error) {
        showCartError(error.description || error.message || 'Impossible d’ajouter cette réservation au panier.');
      })
      .finally(function () { setSubmitting(false); });
  }

  function onProductSubmit(event) {
    if (event.target !== state.form || !document.querySelector('gsp-cart-drawer')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    submitProduct();
  }

  function selectRoomVariant(id) {
    var variant = getVariant(id);
    if (!variant || !variant.available) return;

    var firstOption = variant.options && variant.options[0];
    var topInput = Array.prototype.find.call(
      document.querySelectorAll('[data-rr-booking] input[type="radio"]'),
      function (input) { return input.value === firstOption; }
    );

    if (topInput) {
      topInput.checked = true;
      topInput.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    if (state.variantInput) {
      state.variantInput.value = variant.id;
      state.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    applyVariant(variant);
  }

  function initStickyVisibility() {
    var sticky = document.querySelector('[data-rr-atc-sticky]');
    var mainAtc = document.querySelector('.gsp-main-product__wrap .gsp-block__add_to_cart');
    if (!sticky || !mainAtc || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var active = !entry.isIntersecting;
        sticky.classList.toggle('active', active);
        document.body.classList.toggle('atc-sticky-form-active', active);
        document.body.style.paddingBottom = active ? sticky.offsetHeight + 'px' : '';
      });
    }, { threshold: 0 }).observe(mainAtc);
  }

  function init() {
    var productForm = document.querySelector('[data-rr-primary-product-form]');
    if (!productForm) return;
    state.form = productForm.querySelector('form');
    state.variantInput = state.form && state.form.querySelector('[name="id"]');

    var variantsScript = document.querySelector('[data-rr-product-variants]') || document.querySelector('#productVariants');
    if (variantsScript) {
      try { state.variants = JSON.parse(variantsScript.textContent); } catch (error) { state.variants = []; }
    }

    applyVariant(getVariant(state.variantInput && state.variantInput.value));
    initStickyVisibility();
    observeNativePrice();

    document.addEventListener('submit', onProductSubmit, true);

    if (state.variantInput) {
      state.variantInput.addEventListener('change', function () {
        window.requestAnimationFrame(function () {
          applyVariant(getVariant(state.variantInput.value));
        });
      });
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-rr-select-room]');
      if (!button) return;
      event.preventDefault();
      selectRoomVariant(button.closest('[data-rr-room-variant]').dataset.rrRoomVariant);
    });

  }

  window.RRRetreatVariants = { init: init, select: selectRoomVariant };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
